var trie = (function ()
{
    var trie = {};

    return {
        reset() 
        {
            trie = {};
        },

        add(word) 
        {
            if (word == null || word === '') 
            {
                return;
            }

            let currentNode = trie;
            
            word.toLowerCase().split('').forEach((letter, index) => 
            {
                if (!currentNode[letter]) 
                {
                    currentNode[letter] = {};
                }
                
                // reached the end of the word?
                if (index === word.length - 1) 
                {
                    currentNode.$ = 1;
                }
                else 
                {
                    currentNode = currentNode[letter];
                }
            });
        },

        containsWord(word) 
        {
            if (typeof word !== 'string') 
            {
                throw(`Invalid parameter passed to Trie.containsWord(string word): ${word}`);
            }

            if (word == null || !word) 
            {
                return false;
            }

            let currentNode = trie;
            
            return word.split('').every((letter, index) => 
            {
                if (!currentNode[letter]) 
                {
                    return false;
                }
                
                currentNode = currentNode[letter];

                if (index === word.length - 1) 
                {
                    return currentNode.$ === 1;
                }

                return letter;
            });
        },

        isValidPrefix(prefix) 
        {
            let currentNode = trie;

            return prefix.split('').every(letter => 
            {
                if (!currentNode[letter]) 
                {
                    return false;
                }

                currentNode = currentNode[letter];
                
                return true;
            });
        }
    }
})();

var utils = (function()
{
    return {
        inArray(arr, item) 
        {
            return (arr.indexOf(item) !== -1);
        },
        
        /// checks if two arrays are exactly the same
        // e.g. [1,1] === [1,1], [1,0] !== [1,1]
        arrayMatch(first, second) 
        {
            return first.some((item) => 
            {
                return item.every((x, index) => 
                {
                    return x === second[index];
                });
            });
        },

        getInputValues(inputs) 
        {
            return [].reduce.call(inputs, (acc, input) => 
            {
                if(input.value !== '') 
                {
                    return acc + input.dataset.letter .toLowerCase();
                }

                return acc;
            }, '');
        },
        
        getBoardMatrix(boardSize, letters) 
        {
            let matrix = [];
            let counter = 0;
        
            [].reduce.call(letters, (acc, letter, index) => 
            {
                counter++;
                acc.push(letter);
            
                if(counter === boardSize) 
                {
                    matrix.push(acc);
                    acc = [];
                    counter = 0;
                }
                
                return acc;
            }, []);
        
            return matrix;
        }
    }
})();

const directions = [ [-1, -1], [-1, 0], [-1, 1], [0, -1], [0, 1], [1, -1], [1, 0], [1, 1] ];
let boardMatrix = [];
let wordListObj = [];
var coords = [];
let wordList = [];
let boardSize = 4;

function solveWord() 
{
    var letters = utils.getInputValues(document.querySelectorAll('[data-letter]'));
    letters = letters.replace('qu', 'q');
    
    wordListObj = [];
    wordList = [];
    boardSize = 4;
    boardMatrix = utils.getBoardMatrix(boardSize, letters);
    
    // run solver
    boardMatrix.forEach((row, rowIndex) => 
    {
        row.forEach((col, colIndex) => 
        {
            solveBoard(boardMatrix[rowIndex][colIndex], [rowIndex, colIndex]);
        });
    });
    
    return wordList.length ? wordListObj : null;
}
    
function solveBoard(currentWord, currentPosition, coords = [], usedPositions = []) 
{
    const [row, col] = currentPosition;
    const positions_copy = usedPositions.slice();
    const coords_copy = coords.slice();

    coords_copy.push(currentPosition);

    if (currentWord.length >= 3 
        && trie.containsWord(currentWord) 
        && !utils.inArray(wordList, currentWord)) 
    {
        wordList.push(currentWord);

        wordListObj.push({
            word: currentWord,
            coords: coords_copy
        });

        coords = [];
    }

    const adjacents = getAdjacentLetters(currentWord, currentPosition, usedPositions);

    adjacents.forEach(adjacent => 
    {
        positions_copy.push(currentPosition);

        const [x,y] = adjacent;
        const letter = boardMatrix[x][y];
        const word = currentWord + letter;
    
        solveBoard(word, adjacent, coords_copy, positions_copy);
    });

    return;
}

function getAdjacentLetters(currentWord, position, usedPositions) 
{
    const _directions = directions.slice(0);
    const [row,col] = position;
    
    return _directions.reduce((acc, direction) => 
    {
        const [x, y] = direction;
        const rowSum = (x < 0) ? row - Math.abs(x) : row + x;
        const colSum = (y < 0) ? col - Math.abs(y) : col + y;
    
        if ((rowSum >= 0 && colSum >= 0) && (rowSum < boardSize && colSum < boardSize)) 
        {
            let adjacent = [rowSum, colSum];
            let adjacentWord = currentWord + boardMatrix[rowSum][colSum];
        
            if (!utils.arrayMatch(usedPositions, adjacent) && trie.isValidPrefix(adjacentWord)) 
            {
                acc.push(adjacent);
            }
        }

        return acc;
    }, []);
}

export { solveWord, trie }